//External libraries
import styled from '@emotion/styled';

// Internal modules
import { HEADER_COLOR, TEXT_COLOR } from '@/styles';

const Amount = styled.p`
  font-weight: 500;
  margin-left: 0.5rem;
`;

const StyledCartDropdown = styled.div`
  background-color: #f7f9fa;
  border: 1px solid #ebecec;
  color: ${HEADER_COLOR};
  font-size: 0.95rem;
  font-weight: 400;
  margin-left: -18px;
  margin-right: -18px;
  overflow: hidden;
  padding: 0 18px;
  position: relative;
  z-index: 10;
`;

// workaround for spacing for the animated container
const CartDropdownContainer = styled.div`
  padding-bottom: 12px;
`;

const CurrencyCode = styled.span`
  font-size: 0.75rem;
  font-weight: 400;
  margin-left: 5px;
`;

const Group = styled.div`
  border-bottom: 1px solid #e3e3e3;
  padding: 0.5rem 0;

  &:last-of-type {
    border-bottom: 0;
  }
`;

const ItemDetails = styled.div`
  color: ${TEXT_COLOR};
  font-size: 0.85rem;

  span {
    margin-right: 0.5rem;
  }
`;

const LineClamp = styled.p`
  max-height: 4.05rem;
  overflow: hidden;
  padding-right: 1.15rem;
  position: relative;
  text-align: justify;

  &::before {
    bottom: 0;
    content: '...';
    position: absolute;
    right: 0;
  }

  &::after {
    background: #f7f9fa;
    content: '';
    height: 2.7rem;
    position: absolute;
    right: 0;
    top: 0;
    width: 1rem;
  }
`;

const NoteToBuyer = styled.div`
  background-color: #fff;
  box-sizing: border-box;
  margin: 0 -30px;
  padding: 1px 30px 15px;

  span {
    color: ${TEXT_COLOR};
    font-size: 0.85rem;
  }

  h3 {
    color: ${HEADER_COLOR};
    font-size: 1.17em;
    font-weight: bold;
    margin: 1em 0;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;

  p {
    line-height: 1.35rem;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }

  .total {
    font-weight: 600;
  }
`;

export {
  Amount,
  CartDropdownContainer,
  CurrencyCode,
  Group,
  ItemDetails,
  LineClamp,
  NoteToBuyer,
  Row,
  StyledCartDropdown,
};
